import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingView from '../shared/LoadingView';
import { fetchSelectAction } from '../store/resources';

class LocationWrapper extends Component {
  componentDidMount() {
    this.props.fetchSelect('locations', this.props.match.params.locationId);
  }

  render() {
    const WrappedComponent = this.props.wrap;
    return this.props.location === null ? <LoadingView /> : <WrappedComponent {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    location: state.locations.selected
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchSelect: (resourceName, id) => {
    dispatch(fetchSelectAction(resourceName, id));
  }
});

const ConnectedLocationWrapper = connect(mapStateToProps, mapDispatchToProps)(LocationWrapper);
const withLocation = (wrap) => (props) => <ConnectedLocationWrapper wrap={wrap} {...props} />;

export default withLocation;
